import React from 'react'

const FillShape = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={489.642}
    height={956.859}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12955.14 25316.94"
    {...props}
  >
    <path
      d="M0 14664.28h3890.48l-1381.6 10652.66L12955.14 9695.91h-3500.9L10910.52 0z"
    />
  </svg>
  )
}

export default FillShape